import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContactUsComponent } from './contact-us.component';
import { IconModule } from 'atlas-icon';
import { AccordionModule } from 'atlas-accordion';
import { TabsModule } from 'atlas-tabs';
import { ButtonModule } from 'atlas-button';


@NgModule({
  declarations: [ContactUsComponent],
  imports: [CommonModule, IconModule, AccordionModule, TabsModule, ButtonModule],
  exports: [ContactUsComponent],
  providers: [],
  bootstrap: [],
})
export class ContactUsModule { }
